import { makePatchRequest } from 'owa-ows-gateway';
import { format } from 'owa-localize';
import type { TodoFolder } from 'owa-todo-types';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { TODO_API_UPDATE_TASKFOLDER } from '../utils/constants';
import getTodoRequestHeaders from '../utils/getTodoRequestHeaders';

/**
 * Makes the Patch task call to the server to update a single task folder.
 * @param {string} taskFolderId the id of the task folder to retreive
 */
export default function updateTaskFolderServer(
    taskFolderId: string,
    updates: Partial<TodoFolder>
): Promise<boolean> {
    const url = format(TODO_API_UPDATE_TASKFOLDER, taskFolderId);
    return makePatchRequest(
        url,
        updates,
        null /* correlationId */,
        true /* returnFullResponse */,
        getTodoRequestHeaders()
    )
        .then((response: Response) => {
            return isSuccessStatusCode(response.status);
        })
        .catch(err => {
            return false;
        });
}
